import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import CheckboxUnchecked from '../assets/imgs/checkbox-unchecked.svg'
import CheckboxChecked from '../assets/imgs/checked-checkbox.svg'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#08C4BB',
    },
  },
  typography: {
    fontFamily: [
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontSize: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          background:
            'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 44%, #2992FB 100%) 0% 0% no-repeat padding-box',
          borderRadius: '10px',
          opacity: 1,
          height: '37px',
          color: '#fff',
          textTransform: 'capitalize',
        },
        '&:hover': {
          // backgroundColor: '#000'
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#08C4BB',
          borderRadius: '16px',
          '&.Mui-checked': {
            color: '#08C4BB',
          },
        },
      },
    },
  },
})

const LocationModal = ({ handleLocationModal, locationModal = false }) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [locationCheckboxChecked, setLocationCheckboxChecked] = React.useState(
    user?.allow_location,
  )
  const handleAllowLocationCheckbox = (e) => {
    setLocationCheckboxChecked(e.target.checked)
  }

  const handleAllowLocation = async () => {
    if (locationCheckboxChecked === true) {
      let body = {
        user_id: user?.id,
      }
      let result = await saveOrUpdateDataById('allow-location', body)
      if (result?.data != null && result?.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Location permissions updated successfully!',
          confirmButtonColor: '#2597F6',
        })
        handleLocationModal(false)
      }
    } else {
      handleLocationModal(false)
    }
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <Modal
          open={locationModal}
          onClose={() => handleLocationModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="about-me-modal">
            <h3 className="fs-24 mb-3 fw-bold">Location</h3>
            <div className="text-left">
              <div className="mx-0 text-left">
                <FormControlLabel
                  control={
                    <Checkbox
                      onClick={handleAllowLocationCheckbox}
                      checkedIcon={
                        <img src={CheckboxChecked} alt="Checked Icon" />
                      }
                      icon={
                        <img
                          src={CheckboxUnchecked}
                          alt="Checkbox Unchecked Icon"
                        />
                      }
                    />
                  }
                  label={
                    <Typography
                      style={
                        locationCheckboxChecked
                          ? {
                              fontSize: '15px',
                              fontWeight: 'normal',
                            }
                          : { fontSize: '12px', fontWeight: 'bold' }
                      }
                    >
                      Allow location services
                    </Typography>
                  }
                />
              </div>
              <p
                className={`location-desc ${
                  locationCheckboxChecked
                    ? 'checked-location-checkbox-desc'
                    : ''
                }`}
              >
                Location is required to match you with local Stylist and provide
                accurate pricing
              </p>
              <div className="mt-5 pointer" onClick={handleAllowLocation}>
                <CustomButton title={'Continue'} fullWidth={true} />
              </div>
            </div>
          </Box>
        </Modal>
      </ThemeProvider>
    </>
  )
}

export default LocationModal
